import React from "react";

import Content from "../OtherAssetsModal/components/Content";
import {TabsSharedData} from "../../CustomerDashboardV2/components_v2/TabsSharedData/TabsSharedData";

const OtherAssetsPage = (props) => {
  const {
    isCustomerApp,
    customerId,
    defaultTab,
  } = props;

  const setChanged = () => {};

  return (
    <TabsSharedData>
      <Content
        allowSync={!isCustomerApp}
        customerId={customerId}
        defaultTab={defaultTab}
        setChanged={setChanged}
        withOtherAssets
        withLiabilities
      />
    </TabsSharedData>
  )
};

export default OtherAssetsPage;